import { createSlice } from "@reduxjs/toolkit"



const initialState={
    
    ps:[],
    st:[],
    cy:[]
}

const pensSlice=createSlice({
name:'ps',

initialState,
reducers:{
    
    addStatus:(state,{payload})=>{
        state.st=payload
    },
    addCycle:(state,{payload})=>{
        state.cy=payload
    },
    addPenStatus:(state,{payload})=>{
        state.ps=payload
    },
    logOutPP:(state)=>{
        state.ps=[]
        state.st=[]
        state.cy=[]
    }
    

}
})
export const {logOutPP,addPenStatus,addCycle,addStatus}=pensSlice.actions

export default pensSlice.reducer